/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message[_ngcontent-%COMP%]{text-align:center;margin:50px 0}.message[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#152935}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565656}.message[_ngcontent-%COMP%]   p.text[_ngcontent-%COMP%]{margin:40px 0;font-size:1.2rem}.message[_ngcontent-%COMP%]   p.icon[_ngcontent-%COMP%]{margin:30px 0 0}.message[_ngcontent-%COMP%]   p.icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:inline-block}.message[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}"];
export { styles as styles };
